import React, { useEffect, useState } from 'react';
import Seo from './Seo';
import heroImage from '../assets/wd1.jpg';  
import heroSlide2 from '../assets/wd9.jpg';
import heroSlide3 from '../assets/wd2.jpg';
import heroSlide4 from '../assets/9.jpg';
import serviceImg1 from '../assets/new9.jpg';
import serviceImg2 from '../assets/new91.jpg';
import serviceImg3 from '../assets/new92.jpg';

const Home = () => {
  const slides = [
  {
    src: heroImage,
    alt: 'Electrical and Automation Solutions',
    title: 'Electrical and Automation Solutions',
    subtitle: 'Fusion Tech',
    description: 'We deliver reliable electrical and control solutions for any industrial applications.',
    cardTitle: 'Electrical and Automation Solution',
    cardDescription: 'We deliver reliable electrical and control solutions for any industrial applications.',
    cta: '/services',
  },
  {
    src: heroSlide2,
    alt: 'Project Management Services',
    title: 'Project Management Services',
    subtitle: 'Fusion Tech',
    description: 'We provide professional project management services in different sectors at all stages of a project cycle.',
    cardTitle: 'Project Management Services',
    cardDescription: 'We provide professional project management services in different sectors at all stages of a project cycle.',
    cta: '/services',
  },
  {
    src: heroSlide3,
    alt: 'Export of Machineries and Spare Parts',
    title: 'Export of Machineries and Spare Parts',
    subtitle: 'Fusion Tech',
    description: 'We export machines and spare parts to Middle East, Africa and Asia.',
    cardTitle: 'Export of Machineries and Spare Parts',
    cardDescription: 'We export machines and spare parts to Middle East, Africa and Asia.',
    cta: '/services',
  },
  {
    src: heroSlide4,
    alt: 'After sales support',
    title: 'After Sales Support',
    subtitle: 'Fusion Tech',
    description: 'We support our customers in providing aftersales maintenance and training services.',
    cardTitle: 'After sales support',
    cardDescription: 'We support our customers in providing aftersales maintenance and training services.',
    cta: '/contactus',
  },
];

  const [activeSlide, setActiveSlide] = useState(0);

  useEffect(() => {
    const id = window.setInterval(() => {
      setActiveSlide((prev) => (prev + 1) % slides.length);
    }, 4500);
    return () => window.clearInterval(id);
  }, [slides.length]);

  return (
    <>
      <Seo
        title="Fusion Tech — Electromechanical Systems Supply and Installation in Dubai"
        description="SCADA Solutions in Dubai, UAE; Telemetry Solutions in Dubai UAE; Industrial Automation Dubai UAE; Electrical and Automation Spare Parts; PLC, RTU, DCS, control panels, machine supply, and electromechanical system installation in Dubai."
        url="https://fusiontechuae.com/"
        image="https://fusiontechuae.com/fusion-social.png"
        keywords={`SCADA Solutions in Dubai, UAE, Telemetry Solutions in Dubai UAE, Industrial Automation Dubai UAE, Electrical Spare Parts in Dubai UAE, Automation Spare Parts Dubai UAE, PLC, RTU, DCS from Dubai, Control Panels from Dubai, Machine Supply from Dubai, Electromechanical Systems Supply and Installation in Dubai`}
      />

      <main className="min-h-screen bg-white">
        <section className="bg-white">
          <div className="relative w-full h-[65vh] min-h-[420px] max-h-[760px] overflow-hidden">
            {slides.map((slide, idx) => (
              <div
                key={slide.src}
                className={`absolute inset-0 transition-opacity duration-700 ${idx === activeSlide ? 'opacity-100' : 'opacity-0'}`}
              >
                <img
                  src={slide.src}
                  alt={slide.alt}
                  className="w-full h-full object-cover"
                  loading={idx === 0 ? 'eager' : 'lazy'}
                  decoding="async"
                />
                <div className="absolute inset-0 bg-black/45" />
                <div className="absolute inset-0 flex items-center">
                  <div className="container mx-auto px-6">
                    <div className="max-w-2xl text-white">
                      <p className="uppercase tracking-[0.2em] text-xs sm:text-sm text-white/90">{slide.subtitle}</p>
                      <h1 className="mt-3 text-3xl sm:text-4xl lg:text-6xl font-extrabold leading-tight">{slide.title}</h1>
                      <p className="mt-4 text-base sm:text-lg text-white/90 max-w-xl">{slide.description}</p>
                      <div className="mt-6 flex gap-3">
                        <a href={slide.cta} className="inline-block bg-fusion-blue hover:bg-fusion-blue-dark text-white px-5 py-3 rounded shadow">Explore</a>
                        <a href="/contactus" className="inline-block border border-white/40 text-white px-5 py-3 rounded">Contact Us</a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}

            <div className="absolute left-1/2 bottom-5 -translate-x-1/2 flex items-center gap-3 z-20">
              {slides.map((_, idx) => (
                <button
                  key={idx}
                  type="button"
                  aria-label={`Go to slide ${idx + 1}`}
                  onClick={() => setActiveSlide(idx)}
                  className={`h-3 w-3 rounded-full transition ${idx === activeSlide ? 'bg-white scale-110 shadow-lg' : 'bg-white/50 hover:bg-white/80'}`}
                />
              ))}
            </div>
          </div>

          <div className="container mx-auto px-6 -mt-12 relative z-20">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
              {slides.map((slide, idx) => (
                <button
                  key={slide.cardTitle}
                  type="button"
                  onClick={() => setActiveSlide(idx)}
                  className={`text-left bg-white rounded-xl border p-4 shadow-md transition hover:shadow-xl ${idx === activeSlide ? 'ring-2 ring-fusion-blue border-fusion-blue' : 'border-gray-100'}`}
                >
                  <img src={slide.src} alt={slide.alt} className="w-full h-28 object-cover rounded-lg" loading="lazy" decoding="async" />
                  <h3 className="mt-3 text-base font-semibold text-gray-800">{slide.cardTitle}</h3>
                  <p className="mt-1 text-sm text-gray-600 line-clamp-3">{slide.cardDescription}</p>
                </button>
              ))}
            </div>
          </div>
        </section>

        <section className="container mx-auto px-6 py-16">
          <h2 className="text-2xl font-bold text-gray-800">What We Do</h2>
          <p className="mt-2 text-gray-600 max-w-2xl">
            Explore our specialized pages:{' '}
            <a href="/scada-solutions-dubai" className="text-fusion-blue font-medium">SCADA Solutions in Dubai, UAE</a>
            {' '}and{' '}
            <a href="/electromechanical-systems-dubai" className="text-fusion-blue font-medium">Electromechanical Systems Supply and Installation in Dubai</a>.
          </p>
          <p className="mt-2 text-gray-600 max-w-2xl">We are a premier engineering and trading firm specializing in the supply, installation, and commissioning of electromechanical systems for industrial and commercial sectors. Beyond technical execution, our expert team provides comprehensive project management services tailored to diverse industries. We are committed to delivering excellence and supporting your project’s success from start to finish.</p>

          <div className="mt-8 grid grid-cols-1 md:grid-cols-3 gap-6">
            <article className="border rounded-lg p-6 hover:shadow-lg transition">
              <img src={serviceImg1} alt="Automation" className="w-full h-40 object-cover rounded" />
              <h3 className="mt-4 font-semibold text-lg">Electromechanical and Automation Systems</h3>
              <p className="mt-2 text-gray-600">We provide end-to-end supply and installation of electromechanical and industrial automation solutions. Our expertise spans general telemetry, SCADA, DCS, and factory automation systems tailored for industrial efficiency.</p>
              <a href="/services" className="mt-4 inline-block text-fusion-blue font-medium">Learn more →</a>
            </article>

            <article className="border rounded-lg p-6 hover:shadow-lg transition">
              <img src={serviceImg2} alt="Instrumentation" className="w-full h-40 object-cover rounded" />
              <h3 className="mt-4 font-semibold text-lg">Supply of OEM Parts</h3>
              <p className="mt-2 text-gray-600">We leverage a robust supplier network to source genuine OEM parts at competitive prices with the fastest possible delivery times.</p>
              <a href="/services" className="mt-4 inline-block text-fusion-blue font-medium">Learn more →</a>
            </article>

            <article className="border rounded-lg p-6 hover:shadow-lg transition">
              <img src={serviceImg3} alt="Erection" className="w-full h-40 object-cover rounded" />
              <h3 className="mt-4 font-semibold text-lg">Consultancy Services</h3>
              <p className="mt-2 text-gray-600">We offer expert consultancy to help our clients make data-driven project decisions and maximize cost-efficiency. Our consultancy service is from end-to-end supporting customer projects from initial concept through to final completion.
</p>
              <a href="/services" className="mt-4 inline-block text-fusion-blue font-medium">Learn more →</a>
            </article>
          </div>
        </section>

        <section className="bg-gray-50">
          <div className="container mx-auto px-6 py-12">
            <div className="flex flex-col lg:flex-row items-center gap-8">
              <div className="w-full lg:w-2/3">
                <h3 className="text-2xl font-bold">Talk to Our Team</h3>
                <p className="mt-2 text-gray-600">Looking for reliable supply, seamless installation, or expert industrial guidance? Our team is ready to support your next project. Contact us now to discuss your requirements.</p>
              </div>
              <div className="w-full lg:w-1/3 text-right">
                <a href="/contactus" className="inline-block bg-fusion-blue text-white px-6 py-3 rounded shadow">Get in Touch</a>
              </div>
            </div>
          </div>
        </section>
      </main>
    </>
  );
};

export default Home;


